const searchStrip = {
  hotels: "Hotel", // translated 
  city: "Kota", // translated 
  checkIn: "Mendaftar", // translated 
  checkOut: "Periksa", // translated 
  date: "Tanggal", // translated 
  persons: "orang", // translated 
  adults: "Dewasa", // translated 
  rooms: "Kamar", // translated 
  editSearch: "Sunting Pencarian", // translated 
  newSearch: "Pencarian baru", // translated 
  listView: "Tampilan Daftar", // translated 
  mapView: "Tampilan peta", // translated 
};


export default searchStrip;
